module.exports = __webpack_public_path__ + "media/5.b2646303.wav";